module.exports = "<div fxLayout=\"column\" fxLayoutAlign=\"center center\">\n\n  <p class=\"mat-headline\">\n    Expeditie Moendoes is afgerond!\n  </p>\n  <p class=\"mat-subheading-1\">\n    Jullie hebben heel goed onderzoek gedaan. We weten veel meer over Moendoes! Je kunt altijd terug om te kijken wat er allemaal in het spel gebeurd is.\n  </p>\n\n  <div mat-dialog-actions>\n    <button mat-button class=\"ok-button\" mat-dialog-close=\"ok\">Klaar</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/digi/digi-game/dialog-game-result/dialog-game-result.component.html
// module id = ./src/app/digi/digi-game/dialog-game-result/dialog-game-result.component.html
// module chunks = main